import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DialogBox from '../../../components/shared/DialogBox';
import { Alert, Button, Col, Fade, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { RIEInput } from 'riek'
import { fetchBrokerages } from '../../actions';
import {
    cancelInvitation,
    clearError,
    disableUser,
    enableUser,
    fetchUsers,
    inviteUser,
    resendInvitation,
    revokeUser,
    saveUser,
    changeBrokerage,
    EditUser,
    InviteUser,
    PendingInviteList,
    UserList,
    InviteFailureModal
} from '../../../users';
import {
    fetch as fetchInvites,
    remove as removeInvite
} from './../../../invites/actions';
import { removeAlert } from '../../../alerts';
import { routerActions } from 'connected-react-router';
import _some from 'lodash/some';
import _cloneDeep from 'lodash/cloneDeep';
import isEmpty from 'lodash/isEmpty';
import { updateBrokerage } from '../../api'

import routes from '../../../constants/routes'

export class BrokerageDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            brokerage: null,
            commissionInput: '',
            existingUser: null,
            invites: [],
            invitation: {},
            selectedUser: null,
            showEditModal: false,
            showInviteFailureModal: false,
            users: [],
        };

        this.handleDisableUser = this.handleDisableUser.bind(this);

        this.handleDismissAlert = this.handleDismissAlert.bind(this);

        this.handleEditUser = this.handleEditUser.bind(this);
        this.handleEditUserCancel = this.handleEditUserCancel.bind(this);
        this.handleEditUserSave = this.handleEditUserSave.bind(this);

        this.handleBrokerageChange = this.handleBrokerageChange.bind(this);

        this.handleEnableUser = this.handleEnableUser.bind(this);

        this.handleInviteUserSubmit = this.handleInviteUserSubmit.bind(this);
        this.handleCancelInvitation = this.handleCancelInvitation.bind(this);
        this.handleResendInvitation = this.handleResendInvitation.bind(this);

        this.handleRevokeUser = this.handleRevokeUser.bind(this);

        this.handleBrokerageChangeCancel = this.handleBrokerageChangeCancel.bind(this);
        this.handleCommissionSave = this.handleCommissionSave.bind(this)
    }

    canManageBrokerages(user) {
        if (!user || !user.permissions) return false;
        return _some([
            user.permissions.includes('brokers:read'),
            user.permissions.includes('brokers:write')
        ]);
    }

    componentDidMount() {
        if (!this.canManageBrokerages(this.props.user)) {
            routerActions.push(routes.BROKERAGES);
        } else {
            this.props.fetchBrokerages(this.props.user);
            this.props.fetchUsers(this.props.user);
            const { brokerageId } = this.props.match.params;
            this.props.fetchInvites({
                brokerId: brokerageId
            });
        }
        this.setState({ commissionInput: this.state.brokerage ? this.state.brokerage.commission : 'N/A' })
    }

    componentWillReceiveProps(props) {
        const { brokerageId } = this.props.match.params;

        if (props.brokerages) {
            let brokerage = props.brokerages.find(item => item.brokerId === brokerageId);
            this.setState({
                brokerage: brokerage,
                commissionInput: brokerage ? brokerage.commission : 'N/A'
            });
        }

        if (props.users) {
            const { invitation } = props.users;
            this.setState({
                invitation
            });

            let users = props.users.items.filter(
                item => item.brokerId === brokerageId && item.status !== 'pending'
            );
            this.setState({
                users: users
            });

            if (!isEmpty(props.users.error)) {
                const { errorCode, errorData = {} } = props.users.error;
                const errorCodeType = ["InviteExistsBrokerError", "UserExistBrokerError"];

                if (errorCodeType.includes(errorCode)) {
                    if (props.brokerages) {
                        this.setState({
                            existingBrokerage: props.brokerages.find(
                                item => item.brokerId === errorData.brokerId
                            )
                        });
                    }

                    let existingUser = props.users.items.find(
                        item => item.email === invitation.email
                    ) || { email: invitation.email, isActive: true };

                    this.setState({
                        showInviteFailureModal: true,
                        existingUser
                    });
                } else {
                    this.setState({
                        showInviteFailureModal: false,
                        existingUser: null,
                        existingBrokerage: null
                    });
                }
            } else {
                this.setState({
                    showInviteFailureModal: false,
                    existingUser: null,
                    existingBrokerage: null
                });
            }
        }
    }

    handleBrokerageChangeCancel() {
        this.setState(
            {
                selectedUser: null,
                showEditModal: false,
                showInviteFailureModal: false
            },
            () => {
                if (this.props.clearError) this.props.clearError();
            }
        );
    }

    handleCancelInvitation(record) {
        this.props.removeInvite(record);
    }

    handleDisableUser(user) {
        this.props.disableUser(user, this.props.user);
    }

    handleDismissAlert(alert) {
        if (this.props.removeAlert) {
            this.props.removeAlert(alert);
        }
    }

    handleEditUser(user) {
        this.setState({
            selectedUser: user,
            showEditModal: true
        });
    }

    handleEditUserCancel() {
        this.setState({
            selectedUser: null,
            showEditModal: false
        });
    }

    handleEditUserSave(user) {
        this.props.saveUser(user, this.props.user);
        this.setState({
            selectedUser: null,
            showEditModal: false
        });
    }

    handleBrokerageChange(user, newBrokerage) {
        this.props.changeBrokerage(user, newBrokerage, this.props.user);
        this.setState({
            selectedUser: null,
            showEditModal: false,
            showInviteFailureModal: false
        });
    }

    handleEnableUser(user) {
        this.props.enableUser(user, this.props.user);
    }

    handleInviteUserSubmit(invitation) {
        const { email, isAdmin, type } = invitation;
        const { user } = this.props;
        const { brokerageId } = this.props.match.params;
        this.setState({
            invitation
        });
        this.props.inviteUser(email, isAdmin, type, brokerageId, user);
    }

    handleResendInvitation(user) {
        this.props.resendInvitation(user, this.props.user);
    }

    handleRevokeUser(user) {
        this.props.revokeUser(user, this.props.user);
    }


    async handleCommissionSave(value) {
        this.setState({ commissionInput: value.commissionInput })
        const broker = this.state.brokerage
        broker.commission = value.commissionInput
        await updateBrokerage(broker.brokerId, broker, this.props.user)
    }

    validateCommission(value) {
        return value && !isNaN(value) && (Number(value) >= 0 && Number(value) <= 100)
    }
    render() {
        return (
            <div className="homepageContainer">
                <div className="container">
                    <div className="brokerage routeContainer">
                        {this.props.alerts.map((alert, index) => {
                            return (
                                <Fade key={index} in={true} timeout={5000}>
                                    <Alert bsStyle={alert.type} onDismiss={() => this.handleDismissAlert(alert)}>
                                        <div dangerouslySetInnerHTML={{ __html: alert.message }} />
                                    </Alert>
                                </Fade>
                            );
                        })}
                        <div>
                            <h6 className="agency-code-header">
                                <span className="uppercase">agency #</span>
                                <span>
                                    {this.state.brokerage ? this.state.brokerage.agencyCode : ''}
                                </span>
                            </h6>
                        </div>
                        <div>
                            <h3 className="agency-name-header">
                                {this.state.brokerage ? this.state.brokerage.name : ''}
                            </h3>
                        </div>
                        <div>
                            <h5 className="agency-state-header">
                                {this.state.brokerage ? this.state.brokerage.state : ''}
                            </h5>
                        </div>
                        <div className="agency-detail clearfix">
                            <div className="agency-detail-column pull-left">
                                <div className="title gray">address</div>
                                <div>
                                    {this.state.brokerage ? this.state.brokerage.address1 : ''}
                                </div>
                                <div>
                                    {this.state.brokerage ? this.state.brokerage.address2 : ''}
                                </div>
                                <div>
                                    {this.state.brokerage &&
                                        this.state.brokerage.city && (
                                            <span>{this.state.brokerage.city}</span>
                                        )}
                                    {this.state.brokerage &&
                                        this.state.brokerage.city &&
                                        this.state.brokerage.state && <span>, </span>}
                                    {this.state.brokerage &&
                                        this.state.brokerage.state && (
                                            <span>{this.state.brokerage.state} </span>
                                        )}
                                    {this.state.brokerage &&
                                        this.state.brokerage.zip && (
                                            <span>{this.state.brokerage.zip}</span>
                                        )}
                                </div>
                            </div>
                            <div className="agency-detail-column pull-left">
                                <div className="title gray">commission</div>
                                <div className="inline-edit-commission">
                                    <RIEInput
                                        value={this.state.commissionInput}
                                        change={this.handleCommissionSave}
                                        propName="commissionInput"
                                        classEditing="entity-edit"
                                        classInvalid="entity-invalid"
                                        validate={this.validateCommission}
                                    />%
                                </div>
                            </div>
                        </div>
                        <div className="user-management-container clearfix">
                            <div>
                                <div className="invite-user-container col-lg-4 col-md-4 col-sm-10 col-xs-12">
                                    <InviteUser
                                        adminSelectorVisibility={'visible'}
                                        invitation={this.state.invitation}
                                        isBusy={this.props.users.isBusy}
                                        data={{
                                            brokerageName: this.state.brokerage
                                                ? this.state.brokerage.name
                                                : ''
                                        }}
                                        onSubmit={this.handleInviteUserSubmit}
                                    />
                                </div>
                                <div className="pending-users-container col-lg-8 col-md-8 col-sm-10 col-xs-12">
                                    <PendingInviteList
                                        invites={this.props.invites}
                                        onResendInvitation={this.handleResendInvitation}
                                        onCancelInvitation={this.handleCancelInvitation}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="users-container clearfix">
                            <UserList
                                onDisableUser={this.handleDisableUser}
                                onEditUser={this.handleEditUser}
                                onEnableUser={this.handleEnableUser}
                                onRevokeUser={this.handleRevokeUser}
                                user={this.props.user}
                                users={this.state.users}
                            />
                        </div>
                    </div>
                    <DialogBox
                        title="Edit User"
                        custom_class="editModal"
                        show={this.state.showEditModal}
                        onHide={this.handleEditUserCancel}
                    >
                        {this.state.selectedUser && (
                            <EditUser
                                user={this.state.selectedUser}
                                brokerages={this.props.brokerages}
                                currentBrokerage={this.state.brokerage}
                                adminSelectorDisabled={
                                    this.state.selectedUser.id === this.props.user.id
                                }
                                onCancel={this.handleEditUserCancel}
                                onSave={this.handleEditUserSave}
                                onBrokerageChange={this.handleBrokerageChange}
                            />
                        )}
                    </DialogBox>
                    <DialogBox
                        title="Cannot send invite"
                        custom_class="editModal"
                        show={this.state.showInviteFailureModal}
                        onHide={this.handleBrokerageChangeCancel}
                    >
                        <InviteFailureModal
                            onSave={this.handleBrokerageChange}
                            user={this.state.existingUser}
                            newBrokerage={this.state.brokerage}
                            existingBrokerage={this.state.existingBrokerage}
                            brokerages={this.props.brokerages}
                            onCancel={this.handleBrokerageChangeCancel}
                        />
                    </DialogBox>
                </div>
            </div>
        );
    }
}

BrokerageDetail.propTypes = {
    alerts: PropTypes.array.isRequired,
    brokerages: PropTypes.array.isRequired,
    user: PropTypes.object.isRequired,
    users: PropTypes.object.isRequired,
    changeBrokerage: PropTypes.func.isRequired,
    clearError: PropTypes.func.isRequired,
    disableUser: PropTypes.func.isRequired,
    enableUser: PropTypes.func.isRequired,
    fetchBrokerages: PropTypes.func.isRequired,
    fetchUsers: PropTypes.func.isRequired,
    invites: PropTypes.array,
    inviteUser: PropTypes.func.isRequired,
    removeAlert: PropTypes.func.isRequired,
    resendInvitation: PropTypes.func.isRequired,
    revokeUser: PropTypes.func.isRequired,
    saveUser: PropTypes.func.isRequired
};

const mapStateToProps = store => {
    return {
        alerts: store.alerts.items,
        brokerages: store.brokerages.items,
        invites: store.invites.items,
        user: store.user,
        users: store.users
    };
};

export default connect(mapStateToProps, {
    cancelInvitation,
    changeBrokerage,
    clearError,
    disableUser,
    enableUser,
    fetchBrokerages,
    fetchInvites,
    fetchUsers,
    inviteUser,
    removeAlert,
    removeInvite,
    resendInvitation,
    revokeUser,
    saveUser
})(BrokerageDetail);
